/*
 * Public API Surface of ng-select2
 */

export * from './lib/ng-select2.component';
export * from './lib/ng-select2.module';
export * from './lib/ng-select2.interface';
